import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { capitalize, formatDateForUI, getServiceTypeString } from '../../appointment/appointmentFunctions';
import PatientAppointmentSearchRadius from './PatientAppointmentSearchRadius';

const PatientAppointmentBasicInfo = ({ selectedAppointment, serviceTypes, searchRadius, onSearchRadiusChange, isUpdating }) => {
    const appointment_basic_details = selectedAppointment?.appointment_basic_details;
    if (!appointment_basic_details) {
        return null;
    }

    return (
        <>
            <div className="border-b border-gray-200 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                        <div className="text-sm font-semibold text-gray-500 mb-2">Requested On</div>
                        <div className="text-base font-medium text-gray-800">
                            {formatDateForUI(appointment_basic_details.create_date_time)}
                        </div>
                    </div>
                    <div>
                        <div className="text-sm font-semibold text-gray-500 mb-2">Urgency</div>
                        <div className="text-base font-medium text-gray-800">
                            {appointment_basic_details.urgency_type}
                        </div>
                    </div>
                    <div>
                        {appointment_basic_details.appointment_for !== 'self' && (
                            <DependentInfoSection 
                                appointment_basic_details={appointment_basic_details}
                                dependent_details={selectedAppointment.dependent_details}
                            />
                        )}
                    </div>
                </div>
            </div>
            
            <div className="border-b border-gray-200 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div>
                        <div className="text-sm font-semibold text-gray-500 mb-2">Department</div>
                        <div className="text-base font-medium text-gray-800">
                            {getServiceTypeString(appointment_basic_details.service_type, serviceTypes)}
                        </div>
                    </div>
                    <div>
                        <div className="text-sm font-semibold text-gray-500 mb-2">Symptoms</div>
                        <div className="text-base font-medium text-gray-800">
                            {appointment_basic_details.reason}
                        </div>
                    </div>
                    <div>
                        <div className="text-sm font-semibold text-gray-500 mb-2">Insurance</div>
                        <div className="text-base font-medium text-gray-800">-</div>
                    </div>
                    <div>
                        <PatientAppointmentSearchRadius
                            value={searchRadius}
                            onChange={onSearchRadiusChange}
                            disabled={isUpdating}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const DependentInfoSection = ({ appointment_basic_details, dependent_details }) => {
    return (
        <>
            <div className="text-sm font-semibold text-gray-500 mb-2">Appointment For</div>
            <OverlayTrigger 
                trigger={["hover", "focus", "click"]} 
                placement='auto'
                overlay={
                    <Popover id='tooltip-password'>
                        <Popover.Header className="bg-gray-100 border-b border-gray-200 font-semibold">
                            Dependent Details
                        </Popover.Header>
                        <Popover.Body className="text-sm">
                            <p>Name: {dependent_details.firstname + ' ' + dependent_details.lastname}</p>
                            <p>Age: {dependent_details.age}</p>
                            <p>Gender: {dependent_details.gender}</p>
                        </Popover.Body>
                    </Popover>
                }
            >
                <div className="text-base font-medium text-gray-800 cursor-pointer hover:text-blue-600">
                    {capitalize(appointment_basic_details.appointment_for)}
                </div>
            </OverlayTrigger>
        </>
    );
};

export default PatientAppointmentBasicInfo;
